import { RootState } from 'models/store';

export const selectUserList = (state: RootState) =>
  state.eai.user.userListInterface.userList;

export const selectUserListPage = (state: RootState) =>
  state.eai.user.userListInterface.page;

export const selectUserDetail = (state: RootState) => state.eai.user.userDetail;
